<template>
    <div >
      <div class="checkContent">
        <el-dialog title="巡查详情"
                   :visible.sync="dialogCheck.show" width="640px" :modal-append-to-body='false' :append-to-body="true">
          <el-form :model="form" label-width="86px">
            <div class="form-inline">
              <el-form-item label="添加日期" prop="creatTime" class="form-group">
                <el-input v-model="form.creatTime" disabled></el-input>
              </el-form-item>
              <el-form-item label="巡查日期" prop="searchTime" class="form-group">
                <el-input v-model="form.searchTime" disabled></el-input>
              </el-form-item>
            </div>
            <div class="form-inline">
              <el-form-item label="部位" prop="position" class="form-group">
                <el-input v-model="form.position" disabled></el-input>
              </el-form-item>
              <el-form-item label="病害类型" prop="reason" class="form-group">
                <el-input v-model="form.reason" disabled></el-input>
              </el-form-item>
            </div>
            <div class="form-inline">
              <el-form-item label="描述" prop="described" class="form-group">
                <el-input v-model="form.described " disabled></el-input>
              </el-form-item>
            </div>
                            <div class="pics" v-if="form.imageUrl">
                              <el-form-item label="图片" >
                                <img v-for="item in form.imageUrl.split(',')" :key="item.index" :src="item" @click="handlePictureCardPreview(item)">
                              </el-form-item>
                            </div>
            <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form>
        </el-dialog>
      </div>

    </div>
</template>

<script>
    export default {
        name: 'CheckRecord',
        props:{
          dialogCheck:Object,
          form:Object
        },
        data () {
            return {
                dialogImageUrl: '',
                dialogVisible: false
            }
        },
        methods:{
            handlePictureCardPreview(url){
                // console.log('url: ', url);
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            }
        }
    }
</script>

<style>
  .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%) !important;
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }

  .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }


    .el-form-item{
        margin-bottom: 8px;
    }

</style>

<style scoped>

    .form-group{
        display: inline-block
    }

    .pics{
        /*height: 175px;*/
        /*width: 568px;*/
    }

    .pic{
        height: 170px;
        float: left;
        margin-left: 20px;
        position: relative;
    }

    .pics img{
        display: inline-block;
        position: relative;
        margin: auto;
        height: 150px;
        width: 150px;
        margin-left: 10px;
      /*width:18%;*/
      /*float: left;*/
      /*margin-left:1%;*/
      /*margin-right:1%;*/
      /*display: flex;*/
      /*flex-direction: column;*/
      /*position: relative;*/
      /*margin-bottom: 10px;*/
    }

</style>



// WEBPACK FOOTER //
// src/components/dataManage/CheckRecord.vue